import React, { Component } from 'react'
import { Route, Switch } from 'react-router'
import routes from 'src/routing/routes'
import Plan from './Plan.container'
import PageRegionDep from './scenes/PageRegionDep'
import PageVille from './scenes/PageVille'
import ErrorPage from '../ErrorPage/ErrorPage'
import { isCategoryValid } from '../../../utils'

class PlanRouter extends Component {
  render() {
    const {
      match: { params }
    } = this.props

    return (params.category && isCategoryValid(params.category)) ||
      !params.category ? (
      <Switch>
        <Route exact path={routes.siteMap} component={Plan} />
        <Route exact path={routes.mapRegion} component={PageRegionDep} />
        <Route exact path={routes.mapDepartment} component={PageRegionDep} />
        <Route exact path={routes.mapVille} component={PageVille} />
        <Route component={ErrorPage} />
      </Switch>
    ) : (
      <Route component={ErrorPage} />
    )
  }
}

export default PlanRouter
